import { formatDate, formatDuration } from 'core/utils/date'
import { plural } from 'core/utils/string'

import { type Quote } from '../domain/Quote'
import { type SpotQuoteListLanes } from '../domain/SpotQuoteListLanes'

export function formatRelativeSpotQuoteDeadline(deadline: Date) {
  return formatDuration({
    start: new Date(),
    end: deadline,
  })
}

export function formatSpotQuoteDeadline(bidsDeadline: Date) {
  return formatDate(bidsDeadline, 'MM/dd/yyyy')
}

export function formatMode(quote: Quote) {
  switch (quote.mode) {
    case 'full_truck_load':
      return 'FTL'
    case 'less_than_truckload':
      return 'LTL'
    case 'intermodal':
      return 'IMDL'
    default:
      return 'N/A'
  }
}

export function formatBulkSpotQuoteItemTitle({ total }: SpotQuoteListLanes) {
  return `${total} ${plural('lane', total)} to bid`
}

export function getDeadlineText({
  isExpired,
  isBulkQuote,
}: {
  isExpired: boolean
  isBulkQuote?: boolean
}) {
  let deadlineTimeText

  if (isExpired) {
    deadlineTimeText = isBulkQuote ? 'Latest deadline ended on ' : 'Deadline ended on '
    const sendRatesText = isBulkQuote
      ? "You can't send rates anymore."
      : "You can't send rates for this lane anymore."

    return { deadlineTimeText, sendRatesText }
  }

  deadlineTimeText = isBulkQuote ? 'Earliest deadline ends in' : 'Confirmation deadline ends in'

  return { deadlineTimeText }
}

export function getBulkSpotQuoteItemTagsText({
  expired,
  pending,
  submitted,
}: {
  expired: number
  pending: number
  submitted: number
}) {
  return {
    expiredText: expired > 0 && `${expired} expired`,
    pendingText: pending > 0 && `${pending} pending`,
    submittedText: submitted > 0 && `${submitted} submitted`,
  }
}
